export default __webpack_public_path__ + "static/media/servers.440cea72.jpeg";